const route = {
    path: '/apps',
    meta: { authClass: 'protected' },
    children: [
        {
            path: '',
            components: {
                default:
                    () => import(/* webpackChunkName: "apps" */ '../../components/views/apps.vue'),
            }
        },
    ],
}

module.exports = route;